import React, { Dispatch, SetStateAction } from "react";
import "./CharacterizationRadioQuestion.scss"
import CharacterizationRadio from '../CharacterizationRadio/CharacterizationRadio';
import TextComponent from 'app_components/commons/TextComponent/TextComponent';
import { IQuestionEditor } from "app_components/modules/academicComponentEditor/containers/academicComponentEditorFunctions";
import { IAttemptSurvey } from "app_types/admin/survey/survet.types";
import parse from 'html-react-parser';

interface ICharacterizationRadioQuestionProps {
  question: IQuestionEditor
  attempt: IAttemptSurvey
  setAttempt: Dispatch<SetStateAction<IAttemptSurvey>>
}

function CharacterizationRadioQuestion({ question, attempt, setAttempt }: ICharacterizationRadioQuestionProps){
  const indexInAttempt = attempt?.statistics?.findIndex((answer) => answer.question === question.question._id)

  const handleChange = (answer: string) => {
    const attemptCopy = {...attempt}
    if (indexInAttempt >= 0) {
      attemptCopy.statistics[indexInAttempt].answer = answer
    } else {
      attemptCopy.statistics.push({
        question: question.question._id as string,
        answer
      })
    }
    setAttempt(attemptCopy)
  }

  const getCurrentValue = () => {
    return attempt?.statistics?.find((answer) => answer.question === question.question._id)?.answer
  }

  return(
    <div>
      <TextComponent fontSize="15px" color="rgb(120, 114, 114)" className="characterization-radio-question--subtitle">
        {parse(question.question.content)}
      </TextComponent>

      <div className="characterization-radio-question--container">
        {question?.question?.answers?.map((answer) => (
          <CharacterizationRadio
            checked={getCurrentValue() === answer._id}
            label={parse(answer.content)}
            key={answer._id}
            onClick={() => handleChange(answer._id)}
          />
        ))}
      </div>
    </div>
  )
}

export default CharacterizationRadioQuestion
